import { Component, ElementRef, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { ExternalConfigurationService } from "../../../shared-library/services/configuration/external-configuration.service";
import { BrowserWindowService } from "../../../shared-library/services/environment/browser-window.service";
import { DirectorySearchParametersFactoryService } from "../directory-search/services/directory-search-parameters-factory.service";

@Component({
    selector: "pcg-ng-search-bar",
    templateUrl: "search-bar.component.html",
    imports: [
        FormsModule
    ],
    standalone: true
})
export class SearchBarComponent implements OnInit {
    public formModel: {
        searchText: string
    } = {searchText: ""};

    private searchUrl: string;

    public constructor(
        private _configurationService: ExternalConfigurationService<{ searchUrl: string }>,
        private _browserWindowService: BrowserWindowService,
        private _searchParametersFactory: DirectorySearchParametersFactoryService,
        private domElement: ElementRef
    ) {
    }

    public ngOnInit(): void {
        this._configurationService.initialize(this.domElement);
        this.searchUrl = this._configurationService.config.searchUrl;
        const parameters = this._searchParametersFactory.createFromQueryString(this._browserWindowService.getQueryString());
        this.formModel.searchText = parameters.searchText;
    }

    public submitForm(e: Event): void {
        e.preventDefault();

        const parameters = this._searchParametersFactory.createFromObject({
            searchText: this.formModel.searchText
        });

        window.location.href = window.location.origin
            + this.searchUrl
            + "?" + this._searchParametersFactory.serialiseToQueryString(parameters);
    }
}
